import React from "react";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "material-ui/Table";

import WiremapGenerator from "../../../../../../common/wiremapGenerator";

class WiremapTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const {
      translate,
      classes,
      chartMeasurementUnit,
      data,
      isCoax,
      hideLength,
      isMobileTest
    } = this.props;

    if (data) {
      chartMeasurementUnit &&
        WiremapGenerator.setChartMeasurementUnit(chartMeasurementUnit);
      translate && WiremapGenerator.setTranslate(translate);

      let tableData = WiremapGenerator.generateTableData(data, isCoax, hideLength, isMobileTest);
      let noData = tableData.nodata;
      let lines = tableData.lines;
      return (
        <div className={classes.root}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{translate("wiremap_mainpin")}</TableCell>
                <TableCell>{translate("wiremap_remotepin")}</TableCell>
                <TableCell>{translate("wiremap_faultdesc")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {noData ? (
                <TableRow className={classes.tableRow}>
                  <TableCell
                    className={classes.tableCell}
                    component={() => (
                      <td colSpan="3" align="center">
                        {translate("wiremap_nofault")}
                      </td>
                    )}
                  ></TableCell>
                </TableRow>
              ) : (
                lines.map((d, i) => {
                  return (
                    <TableRow
                      key={`wiremaptable-${i}`}
                      className={classes.tableRow}
                    >
                      <TableCell className={classes.tableCell}>
                        {d.main
                          ? isCoax
                            ? d.main == "4" || d.main == "1"
                              ? "C"
                              : "S"
                            : d.main
                          : d.main}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {d.remote
                          ? isCoax
                            ? d.remote == "4"
                              ? "C"
                              : "S"
                            : d.remote
                          : d.remote}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        <Table className={classes.faultsTable}>
                          <TableBody className={classes.faultsTableBody}>
                            {d.faults.map((f, j) => (
                              <TableRow
                                key={`wiremaptable-${i}-f-${j}`}
                                className={classes.faultsTableRow}
                              >
                                <TableCell className={classes.faultsTableCell}>
                                  {f}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}

export default withStyles(styles)(WiremapTable);
